// "Sign in" links marked [data-signin] open Shopify's sign-in popup (the Account tab) instead of leaving the page.
// If the popup isn't available, the link works normally and opens the sign-in page.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-signin]');
  if (!link) return;
  const popup = document.getElementById('signin-popup');
  const trigger = popup?.shadowRoot?.querySelector('button');
  if (!trigger) return;
  event.preventDefault();
  trigger.click();
});
